import React from 'react';

interface Props {
  height?: number;
  width?: number;
}

export const Space = (props: Props) => {
  const { height, width } = props;
  return <div style={{ height, width }} />;
};
